import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanMatch,
  Route,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { map, Observable } from 'rxjs';

import { MaintenanceService } from '../services/maintenance.service';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceGuard implements CanMatch, CanActivate {
  constructor(private _router: Router, private _service: MaintenanceService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this._getSettings(state.url);
  }

  canMatch(route: Route): Observable<boolean | UrlTree> {
    return this._getSettings(route.path);
  }

  private _getSettings(url: string): Observable<boolean | UrlTree> {
    return this._service.getMaintenanceEnd().pipe(
      map((maintenanceEnd) => {
        const maintenanceTimestamp = maintenanceEnd * 1000;
        const currentTimestamp = Date.now();
        const isMaintenanceEnabled = maintenanceTimestamp > currentTimestamp;

        return url === 'maintenance'
          ? isMaintenanceEnabled
            ? true
            : this._router.createUrlTree(['dashboard'])
          : isMaintenanceEnabled
            ? this._router.createUrlTree(['maintenance'])
            : true
      }),
    );
  }
}
